<template>
    <v-row class="fill-height">
        <v-col class="fill-height" md="12">
            <v-card class="fill-height" style="min-height: 400px;">
                <v-card-title class="pb-2">
                    <v-icon left>mdi-calendar-month</v-icon>
                    Agenda

                    <span class="ml-2">{{ focus | formatDate0 }}</span>

                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>

                    <v-row align="center" justify="space-around">

                        <v-menu
                            v-model="todayMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="auto"
                            offset-y
                            transition="scale-transition"
                        >
                            <template v-slot:activator="{ on, attrs }">


                                <v-btn color="#6D59E8" outlined small v-bind="attrs" v-on="on">
                                    <v-icon left>mdi-calendar</v-icon>
                                    Mudar Data
                                </v-btn>
                            </template>
                            <v-date-picker v-model="focus" locale="pr-br" @input="todayMenu = false"/>
                        </v-menu>

                        <v-btn color="#6D59E8" dark small @click="prev">
                            <v-icon small>
                                mdi-chevron-left
                            </v-icon>
                            Anterior
                        </v-btn>
                        <v-btn color="#3D1159" dark small @click="setToday">
                            Hoje
                        </v-btn>

                        <v-btn color="#6D59E8" dark small @click="next">
                            Próxima
                            <v-icon small>
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>
                    </v-row>
                    <v-btn class="ml-2" color="#ff8c00" icon @click="dialogSubtitle = true">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>

                </v-card-title>
                <v-alert v-if="!todayScheduling.bms.length" class="ma-2" outlined type="warning">
                    Não foi possível processar agenda.
                </v-alert>
                <v-calendar
                    ref="calendar"
                    v-model="focus"
                    :categories="categories"
                    :event-color="getEventColor"
                    :events="events"
                    :first-time="todayScheduling.start"
                    :interval-count="todayScheduling.interval*2"
                    :interval-height="60"
                    :interval-minutes="30"
                    :short-intervals="false"
                    category-show-all
                    category-text="name"
                    color="primary"
                    locale="pt-BR"
                    type="category"
                    @change="fetchEvents"
                    @click:event="showEvent"
                >
                    <template v-if="isToday" v-slot:day-body="{item, date, week }" style="min-width: 250px;">
                        <div
                            :class="{ first: date === week[0].date }"
                            :style="{ top: nowY }"
                            class="v-current-time text-center"
                        ></div>
                    </template>

                    <template v-slot:category="{ category, date }" style="min-width: 250px;">
                        <template>
                            <div class="text-center">
                                {{ category.name }}
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            small
                                            v-bind="attrs"
                                            @click="newSchedule(category.id, date)"
                                            v-on="on"
                                        >
                                            <v-icon small>mdi-calendar-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Novo Agendamento</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </template>

                    <!-- Custom Event Slot -->
                    <template  #event="{ event }">
                        
                        
                        <div class="d-flex align-center" style="max-width: 200px;"> 
                            <div class=" d-flex align-center">
                                <v-tooltip v-if=event.isNewUser top>
                                    <template v-slot:activator="{ on, attrs }">
                                        
                                            <v-icon class="mr-1" v-bind="attrs" v-on="on" small color="amber darken-1">mdi-creation</v-icon>
                                        
                                    </template>
                                    <span>Novo usuário</span>
                                </v-tooltip>
                                <v-tooltip v-if=event.isAppUser top>
                                    <template v-slot:activator="{ on, attrs }">
                                        
                                            <v-icon class="mr-1" v-bind="attrs" v-on="on" small>mdi-cellphone</v-icon>
                                        
                                    </template>
                                    <span>Aplicativo</span>
                                </v-tooltip>
                                <v-tooltip v-if=event.isSubscriptionUser top>
                                    <template v-slot:activator="{ on, attrs }">
                                        
                                            <v-icon class="mr-1" v-bind="attrs" v-on="on" small>mdi-sync</v-icon>
                                        
                                    </template>
                                    <span>Assinatura</span>
                                </v-tooltip>
                                <v-tooltip v-if=!event.isAppUser top>
                                    <template v-slot:activator="{ on, attrs }">
                                        
                                            <v-icon class="mr-1" v-bind="attrs" v-on="on" small>mdi-store-marker</v-icon>
                                        
                                    </template>
                                    <span>Recepção</span>
                                </v-tooltip>
                                <v-tooltip v-if="event.isSubscriptionUser && !event.isPayingUser && event.name && !event.name.toLowerCase().includes('pausa')" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        
                                        <v-icon class="mr-1" color="red lighten-1" v-bind="attrs" v-on="on" small>mdi-alert-circle</v-icon>
                                        
                                    </template>
                                    <span>Inadimplente</span>
                                </v-tooltip>
                            </div>
                            <div style="text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;">
                                {{ event.name }}
                            </div>
                        </div>
                        
                    </template>

                </v-calendar>
            </v-card>
        </v-col>

        <v-dialog v-model="dialog" max-width="90%" persistent>
            <v-card>
                <v-form ref="formSchedule" v-model="formIsValid" v-on:submit.prevent="scheduleSave()">
                    <v-card-title class="text-h5">
                        Novo Agendamento {{ scheduleCreate.date |formatDate0 }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col md="8" sm="12">
                                    <v-autocomplete
                                        v-model="scheduleCreate.personID"
                                        :items="personsSimple"
                                        :loading="personLoading"
                                        :rules="textRules"
                                        :search-input.sync="personSearch"
                                        dense
                                        item-text="name"
                                        item-value="id"
                                        label="Escolha um Cliente"
                                        no-data-text="Nenhum resultado até o momento."
                                        outlined
                                        placeholder="Comece a digitar para pesquisar"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col md="4" sm="">
                                    <v-btn color="#3D1159" dark @click="dialogPerson = true">
                                        <v-icon>mdi-plus</v-icon>
                                        Adicionar
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-for="(service, index) in scheduleCreate.services" :key="'serv'+index">
                                <v-col cols="12" md="4" sm="12">
                                    <v-autocomplete
                                        v-model="service.bmID"
                                        :items="todayScheduling.bms"
                                        :rules="textRules"
                                        dense
                                        item-text="name"
                                        item-value="id"
                                        label="Escolha um Profissional"
                                        outlined
                                        placeholder="Escolha um Profissional"
                                        @change="setBM(service.bmID, index)"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="5" sm="12">
                                    <v-autocomplete
                                        v-model="service.id"
                                        :items="bmsServices[index]"
                                        :rules="textRules"
                                        dense
                                        item-text="name"
                                        item-value="id"
                                        label="Escolha um Serviço"
                                        outlined
                                        placeholder="Escolha um serviço"
                                    >
                                        <template v-slot:selection="{ item }">
                                            {{ item.categoryName }} - {{ item.name }} -
                                            {{ item.customValue !== "0" ? item.customValue : item.value | money }} -
                                            {{ item.duration }} min.
                                        </template>
                                        <template v-slot:item="{ item }">
                                            {{ item.categoryName }} - {{ item.name }} -
                                            {{ item.customValue !== "0" ? item.customValue : item.value | money }} -
                                            {{ item.duration }} min.
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                    sm="12"
                                >
                                    <v-text-field
                                        v-model="service.hour"
                                        v-mask="['##:##']"
                                        :rules="hourRules"
                                        append-icon="mdi-clock-time-seven-outline"
                                        dense
                                        label="Horário de agendamento"
                                        outlined
                                        placeholder="Horário de Agendamento"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="1"
                                    sm="12"
                                >
                                    <v-btn v-show="index==0" class="mt-2" color="success" icon small
                                           @click="scheduleAddService()">
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn v-show="index!=0" class="btn-del mt-2" icon small
                                           @click="scheduleRemoveService(index)">
                                        <v-icon>mdi-minus-circle</v-icon>
                                    </v-btn>

                                </v-col>
                            </v-row>
                        </v-container>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#FF3816"
                            dark
                            @click="scheduleDialogCancel()"
                        >
                            <v-icon>mdi-close</v-icon>
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="success"
                            type="submit"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogPerson"
            max-width="600px"
            persistent
        >
            <v-form ref="formPerson"
                    v-model="formIsValid"
                    v-on:submit.prevent="personSubmit()">
                <v-card class="fill-height">
                    <v-card-title class="text-h5">
                        Adicionar Cliente
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col md="12" sm="12">
                                <v-text-field
                                    v-model="person.name"
                                    :rules="textRules"
                                    dense
                                    label="Nome"
                                    outlined
                                />
                            </v-col>
                            <v-col md="12" sm="12">
                                <v-text-field
                                    v-model="person.cpf"
                                    v-mask="['###.###.###-##']"
                                    :rules="cpfRule"
                                    dense
                                    label="CPF"
                                    outlined
                                />
                            </v-col>
                            <v-col md="12" sm="12">
                                <v-text-field
                                    v-model="person.phone"
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    :rules="telRules"
                                    dense
                                    label="Telefone"
                                    outlined
                                />
                            </v-col>
                            <v-col md="12" sm="12">
                                <v-text-field
                                    v-model="person.birthdate"
                                    v-mask="['##/##/####']"
                                    :rules="dateRule"
                                    dense
                                    label="Data de nascimento"
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-btn
                            color="#FF3816"
                            dark
                            @click="dialogPerson = false"
                        >
                            <v-icon>mdi-close</v-icon>
                            Cancelar
                        </v-btn>

                        <v-btn
                            color="success"
                            type="submit"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            Salvar
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog
            v-model="dialogSchedule"
            persistent
            transition="dialog-bottom-transition"
        >

            <v-card
                color="grey lighten-4"
                flat
                min-width="350px"
            >
                <v-toolbar
                    :color="selectedEvent.color"
                    dark
                >
                    <v-toolbar-title>
                        {{ selectedEvent.details.bmName }} - {{ selectedEvent.details.startTime | formatDateHour }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogSchedule = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="text-h6">
                    <b>Cliente: </b> &nbsp;{{ selectedEvent.details.personName }}
                    <v-spacer></v-spacer>
                    <b>Telefone: </b> {{ selectedEvent.details.personPhone }}
                </v-card-title>
                <v-card-text>

                    <v-card elevation="0">
                        <v-card-text v-if="selectedEvent.details.statusID === 3 " class="pa-2 ">
                            <v-row>
                                <v-col>
                                    Aqui você pode adicionar mais serviços e produtos ao atendimento
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="2" sm="12">
                                    <v-radio-group
                                        v-model="itemType"
                                        class="ma-0"
                                        mandatory
                                        row
                                        @change="resetItem"
                                    >
                                        <v-radio
                                            label="Serviço"
                                            value="service"
                                        ></v-radio>
                                        <v-radio
                                            label="Produto"
                                            value="product"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col v-if="itemType=='service'" cols="12" md="4" sm="12">
                                    <v-autocomplete
                                        v-model="item.serviceID"
                                        :items="servicesSimple"
                                        dense
                                        item-text="name"
                                        item-value="id"
                                        label="Serviço"
                                        outlined
                                        placeholder="Escolha um serviço"
                                    >
                                        <template v-slot:selection="{ item }">
                                            {{ item.categoryName }} - {{ item.name }} - {{ item.value | money }}
                                        </template>
                                        <template v-slot:item="{ item }">
                                            {{ item.categoryName }} - {{ item.name }} - {{ item.value | money }}
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col v-if="itemType=='product'" cols="12" md="4" sm="12">
                                    <v-autocomplete
                                        v-model="item.productID"
                                        :items="productsSimple"
                                        dense
                                        item-text="description"
                                        item-value="id"
                                        label="Produto ou insumo."
                                        outlined
                                        placeholder="Escolha um produto"
                                    >
                                        <template v-slot:selection="{ item }">
                                            {{ item.brand }} - {{ item.description }} - {{
                                                item.salesPrice | money
                                            }}
                                        </template>
                                        <template v-slot:item="{ item }">
                                            {{ item.brand }} - {{ item.description }} - {{
                                                item.salesPrice | money
                                            }}
                                        </template>
                                    </v-autocomplete>

                                </v-col>

                                <v-col cols="12" md="2" sm="12">
                                    <number-input
                                        v-model.number="item.quantity"
                                        :options="optionsNumber"
                                        :rules="textRules"
                                        dense
                                        label="Quantidade"
                                        outlined
                                        placeholder="Quantidade"
                                    >
                                    </number-input>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                    sm="12"
                                >

                                    <number-input
                                        v-model="item.discount"
                                        :options="optionsMoney"
                                        :rules="textRules"
                                        dense
                                        label="Desconto"
                                        outlined
                                        placeholder="Valor do desconto"
                                    >
                                    </number-input>

                                </v-col>
                                <v-col cols="12"
                                       md="2"
                                       sm="12">
                                    <v-btn
                                        color="success"
                                        @click="itemSave(selectedEvent.details.order.id)"
                                    >
                                        <span v-if="isEditItem"><v-icon left>mdi-content-save</v-icon> Salvar</span>
                                        <span v-else><v-icon left>mdi-plus</v-icon> Adicionar</span>
                                    </v-btn>

                                    <v-btn
                                        v-if="isEditItem"
                                        class="ml-2"
                                        color="#FF3816"
                                        outlined
                                        small
                                        @click="itemReset()"
                                    >
                                        <v-icon left>mdi-close</v-icon>
                                        Cancelar
                                    </v-btn>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12"
                                       md="4"
                                       sm="12">
                                    <v-select
                                        v-model="itemAssistant.bsBMID"
                                        :items="assistants"
                                        dense
                                        item-text="nickname"
                                        item-value="id"
                                        label="Assistente"
                                        outlined
                                        placeholder="Escolha um assistente."
                                    >
                                    </v-select>
                                </v-col>
                                <v-col cols="12"
                                       md="3"
                                       sm="12">
                                    <number-input
                                        v-model="itemAssistant.commissionFromBS"
                                        :options="optionsCommission"
                                        append-icon="mdi-percent"
                                        dense
                                        label="Comissão Sobre BS"
                                        outlined
                                        placeholder="Comissão Sobre BS"
                                    >
                                    </number-input>
                                </v-col>
                                <v-col cols="12"
                                       md="3"
                                       sm="12">
                                    <number-input
                                        v-model="itemAssistant.commissionFromBM"
                                        :options="optionsCommission"
                                        append-icon="mdi-percent"
                                        dense
                                        label="Comissão Sobre Profissional"
                                        outlined
                                        placeholder="Comissão Sobre Profissional"
                                    >
                                    </number-input>
                                </v-col>
                                <v-col cols="12"
                                       md="2"
                                       sm="12">
                                    <v-btn
                                        color="success"

                                        @click="itemAssistantSave(selectedEvent.details.order.id)"
                                    >
                                        <v-icon left>mdi-plus</v-icon>
                                        Adicionar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-row v-if="selectedEvent.details.order.assistants">
                            <v-col class="py-0 mb-2" cols="12" md="12" sm="12">
                                <v-card class="elevation-1">
                                    <v-card-title class="py-0">
                                        Assistentes
                                    </v-card-title>
                                    <v-data-table
                                        :headers="headersAssistant"
                                        :items="selectedEvent.details.order.assistants"
                                        class="elevation-0"
                                        dense
                                        hide-default-footer
                                    >
                                        <template v-slot:item.value="{ item }">
                                            {{ item.bmName }}
                                        </template>
                                        <template v-slot:item.commissionFromBM="{ item }">
                                            {{ item.commissionFromBM | percent }}
                                        </template>
                                        <template v-slot:item.commissionFromBS="{ item }">
                                            {{ item.commissionFromBS | percent }}
                                        </template>

                                        <template v-slot:item.id="{ item }">
                                            <v-btn v-show="selectedEvent.details.statusID === 3 " icon x-small
                                                   @click="editItemAssistant(item)">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!--                        <div class="d-flex justify-space-between">-->
                        <!--                            <div><b>Itens:</b></div>-->
                        <!--                            <div>-->
                        <!--                            <v-btn text small @click="newItem(selectedEvent.details.bmID)"-->
                        <!--                                   v-if="selectedEvent.details.statusID==3">-->
                        <!--                                <v-icon>mdi-plus</v-icon>-->
                        <!--                                Adicionar-->
                        <!--                            </v-btn>-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                        <v-row>
                            <v-col class="py-0" cols="12" md="12" sm="12">
                                <v-card class="elevation-1">
                                    <v-card-title class="py-0">
                                        Itens
                                    </v-card-title>
                                    <v-data-table
                                        :headers="headers"
                                        :items="selectedEvent.details.order.items"
                                        class="elevation-1"
                                        dense
                                        hide-default-footer
                                    >
                                        <template v-slot:item.value="{ item }">
                                            {{ item.customValue }}
                                            {{ item.value | money }}
                                        </template>
                                        <template v-slot:item.discount="{ item }">
                                            {{ item.discount | money }}
                                            <!--                                            <v-btn right icon x-small @click="editItem(item)"-->
                                            <!--                                                   v-show="selectedEvent.details.statusID === 3 ">-->
                                            <!--                                                <v-icon>mdi-pencil</v-icon>-->
                                            <!--                                            </v-btn>-->
                                        </template>
                                        <template v-slot:item.totalValue="{ item }">
                                            {{ item.totalValue | money }}
                                        </template>

                                        <template v-slot:item.quantity="{ item }">
                                            <!--                                            <v-btn icon x-small color="red" @click="minusItem(item)"-->
                                            <!--                                                   v-show="selectedEvent.details.statusID === 3 ">-->
                                            <!--                                                <v-icon>mdi-minus</v-icon>-->
                                            <!--                                            </v-btn>-->
                                            {{ item.quantity }}
                                            <!--                                            <v-btn icon x-small color="green" @click="plusItem(item)"-->
                                            <!--                                                   v-show="selectedEvent.details.statusID === 3 ">-->
                                            <!--                                                <v-icon>mdi-plus</v-icon>-->
                                            <!--                                            </v-btn>-->
                                        </template>
                                        <template v-slot:item.actions="{ item }">
                                            <v-btn v-show="selectedEvent.details.statusID === 3 " icon
                                                   @click="editItem(item)">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn v-show="selectedEvent.details.statusID === 3 " class="ms-1"
                                                   icon
                                                   @click="itemDelete(selectedEvent.details.order.id, item.id)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>

                                        </template>

                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="px-2 text-left" cols="12" md="6" sm="6">
                                <div class="px-3"><b>Status: </b> {{ status[selectedEvent.details.statusID - 1] }}</div>
                            </v-col>
                            <v-col class="text-right" cols="12" md="6" sm="6">
                                <div class="px-3"><b>Valor Total: </b> {{
                                        selectedEvent.details.order.totalValue | money
                                    }}
                                </div>
                            </v-col>
                        </v-row>


                        <v-card-actions>
                            <!--                            <v-btn-->
                            <!--                                text-->
                            <!--                                color="secondary"-->
                            <!--                                @click="selectedOpen = false"-->
                            <!--                            >-->
                            <!--                                Fechar-->
                            <!--                            </v-btn>-->
                            <v-btn
                                v-if="selectedEvent.details.statusID != 2 && selectedEvent.details.statusID != 4 && selectedEvent.details.statusID != 5 && selectedEvent.details.statusID != 6"
                                color="#FF3816"
                                outlined
                                small
                                @click="dialogCancel=true"
                            >
                                Cancelar Agendamento
                            </v-btn>
                            <v-spacer></v-spacer>

                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="selectedEvent.details.statusID == 1 "
                                :color="colors[selectedEvent.details.statusID-1]"
                                dark
                                @click="startAttendance( selectedEvent.details.id)"
                            >
                                Iniciar Atendimento
                            </v-btn>
                            <v-btn
                                v-if="selectedEvent.details.statusID == 3"
                                :color="colors[selectedEvent.details.statusID-1]"
                                dark

                                @click="dialogFinishAttendance=true"
                            >
                                Finalizar Atendimento
                            </v-btn>

                        </v-card-actions>
                    </v-card>
                </v-card-text>
            </v-card>
            <!--            </v-card>-->
        </v-dialog>

        <confirm-dialog
            :body="`Finalizar atendimento do cliente ${selectedEvent.details.personName}?`"
            :dialog="dialogFinishAttendance"
            title="Deseja finalizar o atendimento?"
            @dialog-event="attendanceFinish">
        </confirm-dialog>

        <!--        confirm cancel-->
        <confirm-dialog
            :dialog="dialogCancel"
            body="Tem certeza que deseja cancelar este agendamento?"
            cancel-text="Não"
            confirm-text="Sim"
            title="Cancelar Agendamento"
            @dialog-event="scheduleCancel">
        </confirm-dialog>

        <v-dialog v-model="dialogSubtitle" max-width="600px">
            <v-card>
                <v-card-title class="text-center text-h5 justify-center">
                    Legenda de Cores da Agenda
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogSubtitle = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>

                    <v-row>
                        <v-col v-for="(st, index) in status"
                               :key="st+index"
                               sm="6">
                            <v-alert
                                :color="colors[index]"
                                border="left"
                                dark
                                dense
                            >
                                {{ st }}
                            </v-alert>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<style lang="scss">
.v-current-time {
    height: 2px;
    background-color: #ea4335;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;

    &.first::before {
        content: '';
        position: absolute;
        background-color: #ea4335;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-top: -5px;
        margin-left: -6.5px;
    }
}

.v-calendar-daily_head-weekday, .v-calendar-daily_head-day-label {
    display: none !important;
}
</style>
<script>
// import {mapGetters} from "vuex";
// import store from "@/store";
import {mask} from "vue-the-mask";
import NumberInput from '@/components/NumberInput'
import ConfirmDialog from "@/components/ConfirmDialog";


import store from "@/store";

import {mapGetters} from "vuex";
import {
    SCHEDULE_CREATE,
    TODAY_SCHEDULING_GET,
    SCHEDULE_CANCEL,
    SCHEDULE_START_ATTENDANCE,
    SCHEDULE_ADD_ITEM,
    SCHEDULE_DELETE_ITEM,
    PAYMENT_TYPES_GET,
    SCHEDULE_FINISH_ATTENDANCE,
    SCHEDULE_BMS_SERVICES,
    SCHEDULE_ADD_ITEM_ASSISTANT, TODAY_SCHEDULING_GET_PAUSES
} from "@/store/actions/schedule.type";
import {
    SCHEDULE_ADD_SERVICE,
    SCHEDULE_CREATE_RESET_STATE,
    SCHEDULE_REMOVE_SERVICE,
    SCHEDULE_RESET_STATE
} from "@/store/mutations/schedule.type"
import {SERVICES_BM_GET} from "@/store/actions/service.type";

import {PERSON_CREATE, PERSON_SEARCH_NAME} from "@/store/actions/person.type";
import {PERSON_RESET_STATE, SET_PERSONS_SIMPLE} from "@/store/mutations/person.type";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
import {PRODUCTS_SIMPLE_GET} from "@/store/actions/product.type";
import {ASSISTANTS_GET} from "@/store/actions/bm.type";
// import {SET_BRANDS, SET_PRODUCTS_SIMPLE} from "@/store/mutations/product.type";

export default {
    name: "bm",
    directives: {mask},
    props: {
        // id: {
        //   default: 0,
        //   type: Number,
        //   required: true
        // }
    },

    components: {NumberInput, ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(SCHEDULE_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([]).then(() => {
            store.dispatch(PRODUCTS_SIMPLE_GET);
            store.dispatch(PAYMENT_TYPES_GET);
            store.dispatch(ASSISTANTS_GET);
            next();
        });
    },
    data: () => ({
        todayMenu: false,
        today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

        dialogPerson: false,
        dialogItems: false,
        dialogFinishAttendance: false,
        dialogCancel: false,
        dialogSchedule: false,
        dialogSubtitle: false,
        dialog: false,
        itemType: null,

        isEditItem: false,

        // productLoading: false,
        // productSearch: "",
        // serviceLoading: false,
        // serviceSearch: "",

        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 7,
            precision: 2
        },

        optionsNumber: {
            locale: "pt-BR",
            prefix: "",
            length: 5,
            precision: 0
        },

        date: "",
        hour: "",
        personID: "",
        serviceID: 0,
        bmID: 0,
        isToday: true,

        headers: [
            {text: 'Nome', sortable: false, value: 'name'},
            {text: 'Quantidade', sortable: false, value: 'quantity'},
            {text: 'Valor', sortable: false, value: 'value'},
            {text: 'Desconto', sortable: false, value: 'discount'},
            {text: 'Valor Total', sortable: false, value: 'totalValue'},
            {text: '', sortable: false, value: 'actions'}
        ],
        headersAssistant: [
            {text: 'Nome', sortable: false, value: 'bmName'},
            {text: 'Comissão BS', sortable: false, value: 'commissionFromBS'},
            {text: 'Comissão BM', sortable: false, value: 'commissionFromBM'},
            {text: '', sortable: false, value: 'id'},
        ],


        optionsCommission: {
            locale: "pt-BR",
            prefix: "",
            length: 4,
            precision: 2,
        },

        // payments: [
        //     {
        //         paymentTypeID: 0,
        //         value: null
        //     }
        // ],

        item: {
            bmId: 0,
            productID: 0,
            serviceID: 0,
            quantity: 1,
            discount: 0
        },
        itemAssistant: {
            bsBMID: 0,
            commissionFromBM: null,
            commissionFromBS: null
        },

        personLoading: false,
        personSearch: "",

        selectedEvent: {
            details: {
                id: 0,
                bmID: 0,
                bmName: "",
                serviceID: 0,
                serviceName: "",
                personID: 0,
                personName: "",
                statusID: 0,
                startTime: "",
                endTime: "",
                appUser: false,
                order: {
                    id: 0,
                    bsID: 1,
                    bsPersonID: 0,
                    bsPersonName: "",
                    value: 0.0,
                    discount: 0, totalValue: 0.0,
                    obs: "",
                    items: [
                        {
                            id: 0,
                            bsServiceID: 0,
                            bsBmID: 0,
                            bsBmName: "",
                            name: "",
                            value: 0.0,
                            discount: 0,
                            totalValue: 0.0,
                            quantity: 0
                        }],
                    statusID: 0, status: "", createdAT: ""
                },
                createdAt: ""
            }
        },

        selectedElement: null,
        selectedOpen: false,

        //Lista de Usuários
        pagination: {
            sortBy: "name",
        },
        search: "",
        selected: [],
        formIsValid: false,

        timer: '',

        value: '',
        ready: false,
        focus: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        events: [],

        colors: [' purple accent-4', 'red darken-4', 'blue', 'pink accent-2', 'green', 'grey darken-1', 'yellow', 'orange'],
        status: ['Agendado', 'Cancelado', 'Em Atendimento', 'Aguardando Pagamento', 'Concluído/Pago', 'Ausente', 'Atendimento Finalizado', 'Pausa'],
        names: [],
        categories: [],
        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        telRules: [
            v => !!v || "Telefone é obrigatório",
            value => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /(\(?\d{2}\)?\s)?(\d{4,5}-\d{4})$/;
                        return pattern.test(value) || "Informe um telefone válido";
                    }
                }
                return false;
            }
        ],
        dateRule: [
            date => {
                if (!date) return true;
                const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                return pattern.test(date) || "Informe uma data válida."
            }
        ],
        cpfRule: [
            // v => !!v || true,
            strCPF => {
                if (!strCPF) return true;
                strCPF = strCPF.replace(/\D/g, "");
                let Soma;
                let Resto;
                Soma = 0;
                if (strCPF == "00000000000") return "CPF Inválido";
                let i = 0;
                for (i = 1; i <= 9; i++)
                    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
                Resto = (Soma * 10) % 11;

                if (Resto == 10 || Resto == 11) Resto = 0;
                if (Resto != parseInt(strCPF.substring(9, 10))) return "CPF Inválido";

                Soma = 0;
                for (i = 1; i <= 10; i++)
                    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
                Resto = (Soma * 10) % 11;

                if (Resto == 10 || Resto == 11) Resto = 0;
                if (Resto != parseInt(strCPF.substring(10, 11))) return "CPF Inválido";
                return true;
            }
        ],
        hourRules: [
            v => !!v || "Campo obrigatório",
            value => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
                        return (
                            pattern.test(value) || "Informe um horário válido"
                        );
                    }
                }
                return false;
            }
        ],
    }),
    methods: {
        editItem(item) {

            this.item = {
                bmID: item.bmID,
                productID: item.productID,
                serviceID: item.serviceID,
                quantity: item.quantity,
                discount: item.discount,
            }

            if (item.serviceID) {
                this.itemType = 'service'
            }
            if (item.productID) {
                this.itemType = 'product'
            }
            this.isEditItem = true
            // console.log(this.item)
            // console.log(this.item.productID, this.item.serviceID)
            //
        },
        editItemAssistant(item) {

            this.itemAssistant = {
                bsBMID: item.bsBMID,
                commissionFromBM: item.commissionFromBM,
                commissionFromBS: item.commissionFromBS
            }

        },

        plusItem(item) {

            let itemSend = {
                id: this.selectedEvent.details.order.id,
                item: {
                    bmId: item.bmId,
                    productID: item.productID,
                    serviceID: item.serviceID,
                    quantity: item.quantity + 1,
                    discount: item.discount,
                },
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM, itemSend)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atualizado com sucesso";
                    this.resetItem();
                    this.dialogItems = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao atualizar novo item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        minusItem(item) {

            let itemSend = {
                id: this.selectedEvent.details.order.id,
                item: {
                    bmId: item.bmId,
                    productID: item.productID,
                    serviceID: item.serviceID,
                    quantity: item.quantity - 1,
                    discount: item.discount,
                },
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM, itemSend)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atualizado com sucesso";
                    this.resetItem();
                    this.dialogItems = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao atualizar novo item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },

        resetItem() {
            this.item = {
                bmId: 0,
                productID: 0,
                serviceID: 0,
                quantity: 1,
                discount: 0
            }

        },
        resetItemAssistant() {
            this.itemAssistant = {
                bsBMID: 0,
                commissionFromBM: null,
                commissionFromBS: null
            }
        },

        // resetPayment() {
        //     this.payments = [{
        //         paymentTypeID: 0,
        //         value: null
        //     }]
        // },
        // addPayment() {
        //     if (this.payments.length < 10) {
        //         this.payments.push({paymentTypeID: 0, value: null})
        //     }
        // },
        // removePayment(index) {
        //     if (this.payments.length > 1) {
        //         this.payments.splice(index, 1)
        //     }
        // },
        scheduleAddService() {
            if (this.scheduleCreate.services.length < 15) {
                this.$store.commit(SCHEDULE_ADD_SERVICE)
            }
        },
        scheduleRemoveService(index) {
            if (index > 0) this.$store.commit(SCHEDULE_REMOVE_SERVICE, index);
        },
        scheduleDialogCancel() {
            this.dialog = false
            this.$refs.formSchedule.resetValidation()
            this.$store.commit(SCHEDULE_CREATE_RESET_STATE)
        },
        async setBM(bmID, index) {
            await this.$store.dispatch(SCHEDULE_BMS_SERVICES, {id: bmID, index: index})
        },
        async newSchedule(bmID, date) {
            // await this.$store.dispatch(SERVICES_BM_GET, bmID)
            this.dialog = true;
            // this.bmID = bmID;
            this.date = date;
            // this.scheduleCreate.bmID = bmID;
            this.scheduleCreate.date = date;
        },
        async newItem(bmID) {
            await this.$store.dispatch(SERVICES_BM_GET, bmID);
            this.bmID = bmID;
            this.dialogItems = true;
        },
        async startAttendance(id) {
            this.inProgress = true

            await this.$store.dispatch(SCHEDULE_START_ATTENDANCE, id)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atendimento iniciado";

                    this.selectedOpen = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao iniciar atendimento.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        scheduleSave() {
            if (this.$refs.formSchedule.validate()) {

                this.inProgress = true
                this.$store
                    .dispatch(SCHEDULE_CREATE, this.scheduleCreate)
                    .then(async () => {
                        this.inProgress = false;

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        this.scheduleDialogCancel()

                        await this.schedulesUpdate("")
                        // this.$refs.formSchedule.resetValidation();
                        // this.$refs.formSchedule.reset();
                        // this.dialog = false;

                    })
                    .catch(({response}) => {
                        this.inProgress = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar agendamento.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro: " +
                                response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        scheduleCancel(status) {
            this.dialogCancel = false
            if (!status) {
                return
            }
            let id = this.selectedEvent.details.id;

            this.inProgress = true
            this.$store
                .dispatch(SCHEDULE_CANCEL, id)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Cancelado com sucesso";
                    this.selectedOpen = false
                    this.dialog = false;
                    this.dialogCancel = false;
                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao cancelar agendamento.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        itemSave(id) {
            this.item.bmId = this.bmID

            // console.log(schedule)
            this.inProgress = true
            if (this.item.serviceID === 0 && this.item.productID === 0) {
                this.inProgress = false;
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Nenhum serviço ou produto escolhido.";
                return
            }
            let item = {
                id: id,
                item: this.item
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM, item)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";
                    this.resetItem();
                    this.dialogItems = false;
                    this.isEditItem = false

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao salvar item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                    this.isEditItem = false
                });
        },
        itemDelete(orderID, itemID) {

            this.inProgress = true
            let item = {
                orderID: orderID,
                itemID: itemID
            }
            this.$store
                .dispatch(SCHEDULE_DELETE_ITEM, item)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Removido com sucesso";

                    this.dialogItems = false;
                    this.isEditItem = false

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao remover item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                    this.isEditItem = false
                });
        },
        itemReset() {
            this.resetItem();
            this.dialogItems = false;
            this.isEditItem = false

        },

        itemAssistantSave(id) {

            // console.log(schedule)
            this.inProgress = true
            if (this.itemAssistant.bsBMID === 0) {
                this.inProgress = false;
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Nenhum assistente escolhido.";
                return
            }
            if (this.itemAssistant.commissionFromBS === 0 && this.itemAssistant.commissionFromBM) {
                this.inProgress = false;
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Nenhum valor de comissão informado.";
                return
            }
            let item = {
                id: id,
                item: this.itemAssistant
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM_ASSISTANT, item)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";
                    this.resetItemAssistant();
                    this.dialogItems = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao salvar Assistente.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        attendanceFinish(status) {
            this.dialogFinishAttendance = false
            if (!status) {
                return
            }
            let id = this.selectedEvent.details.id

            this.inProgress = true

            this.$store
                .dispatch(SCHEDULE_FINISH_ATTENDANCE, id)
                .then(async () => {
                    this.inProgress = false;

                    await this.schedulesUpdate("")

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atendimento finalizado com sucesso";
                    this.resetItem();

                    this.dialogItems = false;
                    this.dialogPayment = false;
                    this.dialogSchedule = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar atendimento.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        // paymentSave(id) {
        //     this.inProgress = true
        //     let payData = {
        //         id: id,
        //         payments: this.payments
        //     }
        //     // console.log(payData)
        //
        //     this.$store
        //         .dispatch(SCHEDULE_CHARGE, payData)
        //         .then(async () => {
        //             this.inProgress = false;
        //
        //             await this.schedulesUpdate("")
        //
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Salvo com sucesso";
        //             this.resetPayment();
        //             this.resetItem();
        //
        //             this.dialogItems = false;
        //             this.dialogPayment = false;
        //
        //         })
        //         .catch(({response}) => {
        //             this.inProgress = false;
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao salvar pagamentos.";
        //             // console.log(response.data);
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text =
        //                     "Erro: " +
        //                     response.data.message;
        //             }
        //         });
        // },

        async showEvent({nativeEvent, event}) {
            // this.dialogSchedule = true;

            //Stop the click event if it is a pause card
            if (event.color === 'orange') {
                nativeEvent.stopPropagation()
                return
            }

            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.dialogSchedule = true))
            }

            if (this.dialogSchedule) {
                this.dialogSchedule = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            this.bmID = this.selectedEvent.details.bmID;
            await this.$store.dispatch(SERVICES_BM_GET, this.bmID);

            nativeEvent.stopPropagation()
        },

        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            // store.dispatch(USER_SEARCH);
            // console.log("buscar");
        },
        //Fim Methods Lista Usuarios


        //ag
        getCurrentTime() {
            return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
        },
        scrollToTime() {
            const time = this.getCurrentTime()
            const first = Math.max(0, time - (time % 30) - 30)

            this.cal.scrollToTime(first)
        },
        updateTime() {
            setInterval(() => this.cal.updateTimes(), 60 * 1000)
        },

        //
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.focus = ''
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        async fetchEvents({start}) {
            this.date = start.date
            await this.schedulesUpdate(start.date)
        },
        async schedulesUpdate(date) {

            let hj = new Date()
            this.isToday = hj.toISOString().split('T')[0] === date;

            if (date === "") date = this.date

            this.categories = []
            this.bms = []

            await this.$store.dispatch(TODAY_SCHEDULING_GET, date)
            let bms = []

            for (let b = 0; b < this.todayScheduling.bms.length; b++) {
                bms.push(this.todayScheduling.bms[b])
            }

            this.categories = bms

            const events = []

            for (let i = 0; i < this.todayScheduling.schedules.length; i++) {

                let st = this.todayScheduling.schedules[i].startTime.split(" ")[1];
                // let et = this.todayScheduling.schedules[i].endTime.split(" ")[1];
                let event = {
                    name: st + " - " + this.todayScheduling.schedules[i].serviceName + " - " + this.todayScheduling.schedules[i].personName,
                    start: this.todayScheduling.schedules[i].startTime,
                    end: this.todayScheduling.schedules[i].endTime,
                    color: this.colors[this.todayScheduling.schedules[i].statusID - 1],
                    timed: false,
                    category: this.todayScheduling.schedules[i].bmName,
                    details: this.todayScheduling.schedules[i],
                    isAppUser: this.todayScheduling.schedules[i].appUser,
                    isSubscriptionUser: this.todayScheduling.schedules[i].isSubscriptionUser,
                    isPayingUser: this.todayScheduling.schedules[i].isPayingUser,
                    isBirthday: this.todayScheduling.schedules[i].isBirthday,
                    isNewUser: this.todayScheduling.schedules[i].isNewUser,
                    createdAt: this.todayScheduling.schedules[i].createdAt
                }
                events.push(event)

                if (this.todayScheduling.schedules[i].id === this.selectedEvent.details.id) {
                    this.selectedEvent = event;

                    this.bmID = this.todayScheduling.schedules[i].bmID;
                    await this.$store.dispatch(SERVICES_BM_GET, this.bmID);
                }

            }

            this.events = events

            await this.dayOffUpdate(date)
        },
        async dayOffUpdate(date) {

            await this.$store.dispatch(TODAY_SCHEDULING_GET_PAUSES, date)

            if (this.todaySchedulingPauses.pauses == null) {
                return
            }

            const events = []

            for (let i = 0; i < this.todaySchedulingPauses.pauses.length; i++) {

                let sd = this.todaySchedulingPauses.pauses[i].startDate.split(" ")[1];
                let event = {
                    name: sd + " - Pausa",
                    start: this.todaySchedulingPauses.pauses[i].startDate,
                    end: this.todaySchedulingPauses.pauses[i].endDate,
                    color: this.colors[7],
                    timed: true,
                    category: this.todaySchedulingPauses.pauses[i].bmName,
                    details: this.todaySchedulingPauses.pauses[i],
                }
                events.push(event)

            }

            this.events = [].concat.apply(this.events, events);

        },
        personSubmit() {
            if (this.$refs.formPerson.validate()) {


                store.commit(CHANGE_PROGRESS, true);
                // this.bloqueiaEnvio = true;
                this.$store
                    .dispatch(PERSON_CREATE)
                    .then((response) => {
                        store.commit(CHANGE_PROGRESS, false);
                        let persons = [{
                            id: response.data.id,
                            name: this.person.name,
                        }]
                        this.personID = response.data.id;
                        this.$refs.formPerson.resetValidation();
                        store.commit(PERSON_RESET_STATE);
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        this.dialogPerson = false;

                        this.$store.commit(SET_PERSONS_SIMPLE, persons)
                    })
                    .catch(({response}) => {
                        store.commit(CHANGE_PROGRESS, false);

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar Cliente.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text = response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        autoUpdate() {
            this.schedulesUpdate("")
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        }
    },
    mounted() {
        this.$refs.calendar.checkChange()
        this.ready = true
        this.scrollToTime()
        this.updateTime()
    },
    created() {
        this.timer = setInterval(this.autoUpdate, 60000)
    },
    destroyed() {
        this.cancelAutoUpdate();
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["checkUsers", "schedule", "paymentTypes", "productsSimple", "assistants", "todayScheduling", "todaySchedulingPauses", "servicesSimple", "person", "personsSimple", "snackbar", "scheduleCreate", "bmsServices"]),
        cal() {
            return this.ready ? this.$refs.calendar : null
        },
        nowY() {
            return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
        },
    },
    watch: {
        personSearch(val) {
            if (!val) {
                return;
            }
            if (val === "" || val.length < 2) {
                this.$store.commit(SET_PERSONS_SIMPLE, [])
                return;
            }
            this.brandLoading = true;
            this.$store.dispatch(PERSON_SEARCH_NAME, val);
            this.brandLoading = false;

        },
        profitMargin(val) {
            console.log(val)
        }
    },
};
</script>
